import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTenantProfile, useTenantApiToken } from '../../contexts/TenantProfileContext';
import { applyWebsiteHiveProspectIntent } from '../../services/tenantApi';
import {
  clearPendingWebsiteHiveProspectIntent,
  hasPendingWebsiteHiveProspectIntent,
} from '../../utils/websiteHiveProspectIntent';

/**
 * After Auth0 signup/login, persist Hive marketing intent onto the prospect group once.
 */
export default function WebsiteHiveProspectIntentSync(): null {
  const { isAuthenticated } = useAuth0();
  const { kind } = useTenantProfile();
  const getToken = useTenantApiToken();
  const syncStartedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || kind !== 'prospect') return;
    if (!hasPendingWebsiteHiveProspectIntent()) return;
    if (syncStartedRef.current) return;
    syncStartedRef.current = true;

    void applyWebsiteHiveProspectIntent(getToken)
      .then((result) => {
        if (result.consumed) {
          clearPendingWebsiteHiveProspectIntent();
        }
      })
      .catch(() => {
        syncStartedRef.current = false;
      });
  }, [isAuthenticated, kind, getToken]);

  return null;
}
